function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSplash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 107,
    viewBox: "0 0 47 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.2748 106.918L0.873047 88.1925L19.7799 58.3312L7.36325 36.1541L26.4743 0.918457L36.618 6.4261L20.5434 36.0652L33.2131 58.6955L17.6668 83.2489L46.1269 96.4362L41.2748 106.918Z",
    fill: "#14394C",
    style: {
      fill: "#14394C",
      fill: "color(display-p3 0.0784 0.2248 0.2980)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSplash);
export default __webpack_public_path__ + "static/media/logoSplash.f2a64405fd965307409d916769006af5.svg";
export { ForwardRef as ReactComponent };